import { create } from 'zustand';

import { type Nullable } from 'utils/values';

import type { AccessTokenPayload } from '../types';

export type AccessTokenStore = {
  accessToken: Nullable<string>;
  accessTokenPayload: Nullable<AccessTokenPayload>;
  setValue: (accessToken: string, payload: AccessTokenPayload) => void;
};

/**
 * Store for access token.
 *
 * Using useOidcAccessToken directly in the fetch hooks has a serious side effect.
 * Once the access token is updated, the fetch hooks will re-run and thus re-fetch the data.
 *
 * Instead, we use this store to store the access token and its payload, and update it in the background.
 * Whenever FE needs to send a request, we attach the access token from this store.
 */
export const useAccessTokenStore = create<AccessTokenStore>((set) => {
  return {
    accessToken: null,
    accessTokenPayload: null,
    setValue: (accessToken, accessTokenPayload) => set({ accessToken, accessTokenPayload })
  };
});
